import { type Country } from 'src/types/country';

const getCurrentHostname = () =>
  typeof window !== 'undefined' ? window.location.hostname : undefined;

export const getFallbackCountryByHostname = (
  hostname = getCurrentHostname()
): Country =>
  hostname?.endsWith('.sa') || hostname === 'tabby.sa' ? 'KSA' : 'UAE';

export const resolveTabbyCountry = (
  country?: Country,
  hostname?: string
): Country => country ?? getFallbackCountryByHostname(hostname);

export const getTabbyDomain = (
  country?: Country,
  hostname?: string
): 'sa' | 'ai' =>
  resolveTabbyCountry(country, hostname) === 'KSA' ? 'sa' : 'ai';
